import React from 'react';
import clsx from 'clsx';

import './index.scss';
import SuccessText from 'components/atoms/Text/SuccessText';

const PcSuccessArea = ({ message, position = 'absolute' }) => {

  return (
    <div className={clsx(
      'PcSuccessArea',
      { noSuccess: !message },
      { success: !!message },
      { absolute: position === 'absolute' },
      { relative: position === 'relative' },
    )}
    >
      <div className="M-SA-message">
        <SuccessText label={message} />
      </div>
    </div>
  );
};

export default PcSuccessArea;